import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ZapIcon, ShieldIcon, CreditCardIcon, FileTextIcon, FlagIcon } from 'lucide-react';
export function FinalCTA() {
  const trustBadges = [{
    icon: <LockIcon className="w-5 h-5" data-id="element-68" />,
    text: 'Pago 100% seguro'
  }, {
    icon: <ZapIcon className="w-5 h-5" data-id="element-69" />,
    text: 'Acceso en 5 minutos'
  }, {
    icon: <ShieldIcon className="w-5 h-5" data-id="element-70" />,
    text: 'Garantía 7 días'
  }, {
    icon: <CreditCardIcon className="w-5 h-5" data-id="element-71" />,
    text: 'Mercado Pago · Tarjeta · Transferencia'
  }, {
    icon: <FileTextIcon className="w-5 h-5" data-id="element-72" />,
    text: '100% PDF'
  }, {
    icon: <FlagIcon className="w-5 h-5" data-id="element-73" />,
    text: 'Hecho en Argentina'
  }];
  return <section className="w-full bg-[#FFFFFF] py-16 md:py-24" data-id="element-74">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-75">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-76">
          <div className="max-w-3xl mx-auto mb-12" data-id="element-77">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="bg-[#F7F2EA] border border-[#E7DDD2] rounded-3xl p-8 md:p-12 relative shadow-premium text-center" data-id="element-78">
              <h4 className="font-serif text-2xl md:text-4xl font-bold text-[#3E2B1F] mb-4" data-id="element-79">
                MEGA PACK EMPRENDE MINIDONAS 360
              </h4>
              <p className="text-[#B66A2C] font-semibold mb-8 text-lg" data-id="element-80">
                6 Tomos + 4 Bonos · Masa → Negocio en Pesos
              </p>

              <div className="bg-white rounded-2xl p-6 mb-8 border border-[#E7DDD2]" data-id="element-81">
                <div className="flex items-center justify-center gap-3 mb-2" data-id="element-82">
                  <span className="text-[#3E2B1F]/50 line-through text-xl font-medium" data-id="element-83">
                    $58.960
                  </span>
                  <span className="bg-[#3E2B1F] text-white text-xs font-bold px-3 py-1 rounded-full tracking-widest" data-id="element-84">
                    -71% OFF
                  </span>
                </div>
                <div className="flex items-baseline justify-center gap-2" data-id="element-85">
                  <span className="text-[#C96B17] font-bold text-5xl md:text-6xl font-serif" data-id="element-86">
                    $16.990
                  </span>
                  <span className="text-[#3E2B1F]/60 text-base font-medium" data-id="element-87">
                    ARS
                  </span>
                </div>
              </div>

              <motion.a href="https://www.recursohub.com/cart/48199368966336:1" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="block w-full bg-[#C96B17] hover:bg-[#A95712] text-white font-bold text-xl px-8 py-5 rounded-2xl transition-all duration-300 shadow-premium hover:shadow-premium-hover mb-4" data-id="element-88">
                QUIERO MI MEGA PACK AHORA
              </motion.a>

              <motion.a href="https://wa.me/543516347235?text=Hola!!%20Quiero%20abonar%20el%20Mega%20Pack%20Emprende%20Minidonas%20360%20con%20transferencia%20bancaria%20y%20aprovechar%20el%2015%25%20de%20descuento.%20Gracias!!" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="flex items-center justify-center gap-3 w-full bg-white hover:bg-[#F7F2EA] border-2 border-[#E7DDD2] text-[#3E2B1F] font-bold text-lg px-6 py-4 rounded-2xl transition-all duration-300" data-id="element-89">
                <svg className="w-5 h-5 text-[#25D366]" viewBox="0 0 24 24" fill="currentColor" data-id="element-90">
                  <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" data-id="element-91" />
                </svg>
                Pagar por transferencia — 15% OFF ($14.441)
              </motion.a>
            </motion.div>
          </div>

          <div className="flex flex-wrap gap-3 md:gap-4 items-center justify-center max-w-4xl mx-auto" data-id="element-92">
            {trustBadges.map((badge, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05,
            duration: 0.4
          }} className="flex items-center gap-2 bg-white border border-[#E7DDD2] rounded-full px-4 py-2 shadow-sm" data-id="element-93">
                <span className="text-[#B66A2C]" data-id="element-94">{badge.icon}</span>
                <span className="text-xs md:text-sm text-[#3E2B1F]/80 font-medium" data-id="element-95">
                  {badge.text}
                </span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}